import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuditoriaXmlSri() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState(null);

  const auditar = async () => {
    setLoading(true);
    setOpen(true);
    try {
      const { data } = await api.get("/invoicing/auditoria-xml");
      setRes(data);
    } catch (e) {
      toast.error(formatApiError(e));
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        className="border-[#d1dbd6]"
        onClick={auditar}
        data-testid="auditar-xml-btn"
      >
        <ShieldCheck className="h-4 w-4 mr-2" /> Auditar XML
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl" data-testid="auditoria-xml-dialog">
          <DialogHeader>
            <DialogTitle>Auditoría de estructura XML · normativa SRI</DialogTitle>
          </DialogHeader>
          {loading && (
            <div className="flex items-center gap-2 text-sm text-[#4a5c53] py-8 justify-center">
              <Loader2 className="h-4 w-4 animate-spin" /> Revisando comprobantes…
            </div>
          )}
          {!loading && res && (
            <div className="space-y-3 max-h-[60vh] overflow-auto">
              <div className="text-sm text-[#4a5c53]" data-testid="auditoria-xml-resumen">
                {res.revisados} comprobantes revisados ·{" "}
                <span className={res.con_errores ? "text-red-700 font-semibold" : "text-emerald-700 font-semibold"}>
                  {res.con_errores} con observaciones
                </span>
              </div>
              {res.con_errores === 0 && (
                <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="auditoria-xml-ok">
                  Todos los XML revisados cumplen la estructura exigida por el SRI.
                </div>
              )}
              {(res.hallazgos || []).map((h, i) => (
                <div key={i} className="rounded-lg border border-red-200 bg-red-50 p-3" data-testid={`auditoria-xml-hallazgo-${i}`}>
                  <div className="text-sm font-semibold text-[#15241d]">
                    {h.tipo} {h.numero} {h.nombre ? `· ${h.nombre}` : ""}
                    {h.estado_sri ? <span className="ml-2 text-xs uppercase text-[#5c7368]">{h.estado_sri}</span> : null}
                  </div>
                  <ul className="mt-1 list-disc pl-5 text-xs text-red-800 space-y-0.5">
                    {(h.errores || []).map((e, j) => <li key={j}>{e}</li>)}
                  </ul>
                </div>
              ))}
              <p className="text-xs text-[#5c7368]">
                Al firmar de nuevo un comprobante rechazado, el XML se regenera y los números
                de documento se corrigen automáticamente (ceros faltantes, espacios y guiones).
              </p>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid="auditoria-xml-cerrar">Cerrar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
